// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-portal-target {\n  position: relative;\n  z-index: 51;\n}", ""]);
// Exports
module.exports = exports;
